import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { StateService } from "src/app/services/state.service";
import { RestService } from "src/app/services/rest.service";

@Component({
  selector: "app-user",
  templateUrl: "./user.component.html",
  styleUrls: ["./user.component.css"]
})
export class UserComponent implements OnInit {
  isCollapsed = false;

  constructor(
    private router: Router,
    public _state: StateService,
    private _rest: RestService
  ) {}
  ngOnInit(): void {
    this.getPilots();
  }

  logout() {
    localStorage.removeItem("token");
    this._state.isLogin = false;
    this.router.navigate(["/login"]);
  }
  getPilots() {
    this._rest.getPilots().subscribe(
      resp => {
        this._state.pilotList = [];
        this._state.pilotList = resp["RESULT"];
      },
      err => {}
    );
  }
}
